import type { CalendarConnectionsState } from './ducks';

interface RootSlice { calendarConnections?: CalendarConnectionsState }

export const selectConnections = (s: RootSlice) => s.calendarConnections?.connections ?? [];
export const selectConnectionsLoading = (s: RootSlice) => s.calendarConnections?.loading ?? false;
export const selectConnectionsError = (s: RootSlice) => s.calendarConnections?.error ?? null;
export const selectModalStep = (s: RootSlice) => s.calendarConnections?.modalStep ?? 'closed';
export const selectModalProvider = (s: RootSlice) => s.calendarConnections?.modalProvider ?? null;
export const selectDiscoveredApple = (s: RootSlice) => s.calendarConnections?.discoveredApple ?? [];
export const selectDiscoveredGoogle = (s: RootSlice) => s.calendarConnections?.discoveredGoogle ?? [];
export const selectPendingApple = (s: RootSlice) => s.calendarConnections?.pendingApple ?? null;
export const selectManaging = (s: RootSlice) => s.calendarConnections?.managingConnectionId ?? null;
export const selectModalSubmitting = (s: RootSlice) => s.calendarConnections?.modalSubmitting ?? false;
export const selectModalError = (s: RootSlice) => s.calendarConnections?.modalError ?? null;
export const selectManageSubcalendars = (s: RootSlice) => s.calendarConnections?.manageSubcalendars ?? [];
